import { Controller } from "@hotwired/stimulus"
import Tags from "bootstrap5-tags";

export default class extends Controller {
  static targets = [ "element" ]
  connect() {
    const el = this.elementTarget
    const opts = {
      allowClear: true,
      showDropIcon: false,
      allowNew: el.dataset.allowNew === "true",
      addOnBlur: el.dataset.addOnBlur === "true"
    }
    Tags.init("#" + el.id, opts);
  }
}
